import CircularProgress from '@mui/material/CircularProgress';
import { Button, ButtonProps } from '@mui/material';

export interface SubmitButtonProps extends ButtonProps {
  text: string;
  isSubmitting: boolean;
}

function SubmitButton({ text, isSubmitting, ...rest }: SubmitButtonProps) {
  return (
    <>
      <Button type="submit" fullWidth variant="contained" color="primary" disabled={isSubmitting} {...rest}>
        {text}
      </Button>
      {isSubmitting && (
        <CircularProgress
          size={30}
          sx={{
            color: (theme) => theme.palette.secondary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-15px',
            marginLeft: '-15px',
          }}
        />
      )}
    </>
  );
}

export default SubmitButton;
